export const LOGIN_PATH = '/login';
export const FORGOT_PASSWORD_PATH = '/forgot-password';
export const FORGOT_PASSWORD_EMAIL_SENT_PATH =
  '/forgot-password/email-sent-success';
export const RESET_PASSWORD_PATH = '/reset-password';
